import * as React from 'react'
import i18next from 'i18next'
import { Button, Form, Alert } from 'react-bootstrap'
import { updateFormData, resetMessage, submitForgotPassword } from 'src/store/login'
import { Trans } from 'react-i18next'

const { t } = i18next

class ForgotPasswordVariant extends React.Component {
  handleChange = ({ target }) => {
    let { name, value } = target
    if (name === 'username_or_email' && value) {
      value = value.toLowerCase().trim()
    }
    this.props.dispatch(updateFormData({ name, value }))
  }

  resetMessage = () => {
    this.props.dispatch(resetMessage())
  }

  handleSubmitForgotPwd = async () => {
    let { username_or_email } = this.props.loginData
    this.props.dispatch(submitForgotPassword({ tenant: this.props.tenant, username_or_email }))
  }

  componentWillUnmount() {
    this.props.dispatch(updateFormData({ name: 'username_or_email', value: '' }))
  }

  render() {
    let { message_type, message, loading, username_or_email } = this.props.loginData

    return (
      <div className="card-body p-3 pt-2">
        <div className="mb-5">
          <h4 className="mb-3 text-center">
            <Trans i18nKey="system_wide.login_form.recovery_password">Recupera password</Trans>{' '}
          </h4>
        </div>
        <Alert variant={message_type} show={message !== ''} onClose={this.resetMessage}>
          {message}
        </Alert>
        <Form className="mb-2">
          <Form.Group className="mb-3">
            <Form.Label>
              <Trans i18nKey="system_wide.login_form.username_or_email">Username o email</Trans>
            </Form.Label>
            <Form.Control
              name="username_or_email"
              className="text-lowercase"
              autoComplete="off"
              placeholder={t('system_wide.login_form.username_or_email', 'Username o email')}
              value={username_or_email}
              onChange={this.handleChange}
            />
            <Form.Text>
              <Trans i18nKey="system_wide.login_form.create_password_instructions">
                Inserisci lo username o email e ti invieremo le istruzioni per creare una nuova password
              </Trans>
            </Form.Text>
          </Form.Group>
          <div className="mt-3 text-center">
            <Button
              style={{ minWidth: '6rem' }}
              color="primary"
              size="md"
              disabled={username_or_email === '' || loading === true}
              onClick={this.handleSubmitForgotPwd}>
              {loading === true && (
                <>
                  <span className="spinner-border spinner-border-sm"></span>{' '}
                  <Trans i18nKey="buttons.send_email">Invia email</Trans>
                </>
              )}
              {loading === false && <Trans i18nKey="buttons.send">Invia</Trans>}
            </Button>
          </div>
        </Form>
        <button className="link-button" onClick={this.props.handleForgotPassword}>
          « <Trans i18nKey="buttons.back_to_login">Torna al login</Trans>
        </button>
      </div>
    )
  }
}

export default ForgotPasswordVariant
